import emailjs from '@emailjs/browser';

// EmailJS configuration - Sử dụng environment variables hoặc fallback
const EMAIL_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_nm8wvyl',
  
  // Template IDs for different types of emails - Sử dụng cùng template cho contact và subscription
  jobApplicationTemplateId: process.env.REACT_APP_EMAILJS_JOB_TEMPLATE_ID || 'template_3h67tid',
  unifiedTemplateId: process.env.REACT_APP_EMAILJS_UNIFIED_TEMPLATE_ID || 'template_c3dmw1l', // Template chung cho contact và subscription
  
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'scU6JcJHOEVmHT0dN',
  
  // Legacy support - deprecated, sử dụng unifiedTemplateId thay thế
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_3h67tid',
  contactTemplateId: process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID || 'template_c3dmw1l',
  subscriptionTemplateId: process.env.REACT_APP_EMAILJS_SUBSCRIPTION_TEMPLATE_ID || 'template_c3dmw1l',
};

// Company configuration
const COMPANY_CONFIG = {
  email: process.env.REACT_APP_COMPANY_EMAIL || 'support@phucansolutions.vn',
  name: process.env.REACT_APP_COMPANY_NAME || 'PhucAn Solutions',
};

// Initialize EmailJS
export const initEmailJS = () => {
  console.log('🔧 Initializing EmailJS with config:', EMAIL_CONFIG);
  
  if (EMAIL_CONFIG.publicKey && EMAIL_CONFIG.publicKey !== 'YOUR_PUBLIC_KEY') {
    try {
      emailjs.init(EMAIL_CONFIG.publicKey);
      console.log('✅ EmailJS initialized successfully');
      return true;
    } catch (error) {
      console.error('❌ EmailJS initialization failed:', error);
      return false;
    }
  } else {
    console.warn('⚠️ EmailJS not configured. Public key missing or invalid.');
    return false;
  }
};

// Send job application email
export const sendJobApplication = async (applicationData, jobData) => {
  console.log('📧 Starting email send process...');
  console.log('Application data:', applicationData);
  console.log('Job data:', jobData);
  
  // Check if EmailJS is properly configured
  if (!EMAIL_CONFIG.publicKey || EMAIL_CONFIG.publicKey === 'YOUR_PUBLIC_KEY') {
    console.warn('⚠️ EmailJS not configured properly.');
    return {
      success: false,
      message: 'EmailJS chưa được cấu hình đúng. Sử dụng phương thức email client.',
    };
  }

  try {
    const templateParams = {
      // Recipient info
      to_email: COMPANY_CONFIG.email,
      to_name: `${COMPANY_CONFIG.name} HR Team`,
      
      // Job info
      job_title: jobData.title || 'N/A',
      job_id: jobData.id || 'N/A',
      job_department: jobData.department || 'N/A',
      job_location: jobData.location || 'N/A',
      
      // Applicant info
      from_name: applicationData.fullName || 'N/A',
      from_email: applicationData.email || 'N/A',
      phone: applicationData.phone || 'N/A',
      experience: applicationData.experience || 'Chưa được chọn',
      cover_letter: applicationData.coverLetter || 'Không có thư giới thiệu',
      
      // Additional info
      application_date: new Date().toLocaleString('vi-VN'),
      reply_to: applicationData.email || 'N/A',
    };

    console.log('📧 Template params:', templateParams);
    console.log('📧 EmailJS config:', {
      serviceId: EMAIL_CONFIG.serviceId,
      templateId: EMAIL_CONFIG.templateId,
      publicKey: EMAIL_CONFIG.publicKey ? EMAIL_CONFIG.publicKey.substring(0, 10) + '...' : 'Missing'
    });

    const response = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.jobApplicationTemplateId,
      templateParams
    );

    console.log('✅ EmailJS response:', response);

    if (response.status === 200) {
      return {
        success: true,
        message: `Email ứng tuyển đã được gửi thành công đến ${COMPANY_CONFIG.email}!`
      };
    } else {
      throw new Error(`EmailJS returned status: ${response.status}`);
    }
  } catch (error) {
    console.error('❌ EmailJS Error Details:', {
      message: error.message,
      status: error.status,
      text: error.text,
      error: error
    });
    
    return {
      success: false,
      message: `Lỗi gửi email: ${error.message || 'Unknown error'}. Sử dụng phương thức email client.`,
      error: error.message
    };
  }
};

// Send contact form email
export const sendContactForm = async (formData) => {
  console.log('📧 Sending contact form email...');
  console.log('Contact data:', formData);
  
  // Check if EmailJS is properly configured
  if (!EMAIL_CONFIG.publicKey || EMAIL_CONFIG.publicKey === 'YOUR_PUBLIC_KEY') {
    console.warn('⚠️ EmailJS not configured properly.');
    throw new Error('EmailJS chưa được cấu hình đúng');
  }

  try {
    const templateParams = {
      // Email type and header
      email_type: 'Tin nhắn mới từ website',
      
      // Contact form content - hiển thị
      contact_content_display: 'block',
      subscription_content_display: 'none',
      
      // Contact form info
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone || 'Không cung cấp',
      subject: formData.subject,
      message: formData.message,
      contact_date: new Date().toLocaleString('vi-VN'),
      reply_to: formData.email,
      
      // Display control for phone (hide if empty)
      phone_display: formData.phone ? 'block' : 'none',
      
      // Hide subscription fields
      subscriber_email: '',
      subscription_date: '',
      
      // General info
      to_email: COMPANY_CONFIG.email,
      to_name: `${COMPANY_CONFIG.name} Team`,
    };

    console.log('📧 Contact template params:', templateParams);

    const response = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.unifiedTemplateId,
      templateParams
    );

    console.log('✅ Contact EmailJS response:', response);

    if (response.status === 200) {
      return {
        success: true,
        message: 'Tin nhắn đã được gửi thành công! Chúng tôi sẽ phản hồi trong vòng 24 giờ.'
      };
    } else {
      throw new Error(`EmailJS returned status: ${response.status}`);
    }
  } catch (error) {
    console.error('❌ Contact EmailJS Error:', error);
    throw new Error(`Lỗi gửi email: ${error.message || 'Unknown error'}`);
  }
};

// Send subscription email
export const sendSubscription = async (email) => {
  console.log('📧 Sending subscription email...');
  console.log('Subscription email:', email);
  
  // Check if EmailJS is properly configured
  if (!EMAIL_CONFIG.publicKey || EMAIL_CONFIG.publicKey === 'YOUR_PUBLIC_KEY') {
    console.warn('⚠️ EmailJS not configured properly.');
    throw new Error('EmailJS chưa được cấu hình đúng');
  }

  try {
    const templateParams = {
      // Email type and header
      email_type: 'Đăng ký nhận tin mới',
      
      // Subscription content - hiển thị
      contact_content_display: 'none',
      subscription_content_display: 'block',
      
      // Subscription info
      subscriber_email: email,
      subscription_date: new Date().toLocaleString('vi-VN'),
      
      // Hide contact fields
      from_name: '',
      from_email: '',
      phone: '',
      subject: '',
      message: '',
      contact_date: '',
      reply_to: '',
      phone_display: 'none',
      
      // General info
      to_email: COMPANY_CONFIG.email,
      to_name: `${COMPANY_CONFIG.name} Marketing Team`,
    };

    console.log('📧 Subscription template params:', templateParams);

    const response = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.unifiedTemplateId,
      templateParams
    );

    console.log('✅ Subscription EmailJS response:', response);

    if (response.status === 200) {
      return {
        success: true,
        message: 'Đăng ký thành công! Cảm ơn bạn đã quan tâm đến PhucAn Solutions.'
      };
    } else {
      throw new Error(`EmailJS returned status: ${response.status}`);
    }
  } catch (error) {
    console.error('❌ Subscription EmailJS Error:', error);
    throw new Error(`Lỗi đăng ký: ${error.message || 'Unknown error'}`);
  }
};

// Fallback: Open email client with pre-filled content
export const openEmailClient = (applicationData, jobData) => {
  console.log('📧 Opening email client fallback...');
  
  const emailSubject = `Ứng tuyển: ${jobData.title} - ${applicationData.fullName}`;
  const emailBody = `
Kính gửi ${COMPANY_CONFIG.name} HR Team,

Tôi viết email này để ứng tuyển vào vị trí "${jobData.title}" tại ${jobData.department}.

THÔNG TIN CÁ NHÂN:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
👤 Họ và tên: ${applicationData.fullName}
📧 Email: ${applicationData.email}
📞 Số điện thoại: ${applicationData.phone}
💼 Kinh nghiệm: ${applicationData.experience || 'Chưa được chọn'}

THÔNG TIN CÔNG VIỆC:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
💼 Vị trí ứng tuyển: ${jobData.title}
🏢 Phòng ban: ${jobData.department}
📍 Địa điểm: ${jobData.location}

THƯ GIỚI THIỆU:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
${applicationData.coverLetter || 'Tôi rất mong được cơ hội làm việc tại ' + COMPANY_CONFIG.name + ' và đóng góp vào sự phát triển của công ty.'}

Tôi đã đính kèm CV/Resume trong email này. Mong nhận được phản hồi từ quý công ty.

Trân trọng,
${applicationData.fullName}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📅 Thời gian ứng tuyển: ${new Date().toLocaleString('vi-VN')}
  `.trim();

  const mailtoLink = `mailto:${COMPANY_CONFIG.email}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
  
  console.log('📧 Opening email client with:', {
    to: COMPANY_CONFIG.email,
    subject: emailSubject
  });
  
  window.open(mailtoLink, '_blank');
};

// Test function để debug
export const testEmailJS = async () => {
  console.log('🧪 Testing EmailJS configuration...');
  
  const testData = {
    fullName: 'Test User',
    email: 'test@example.com',
    phone: '0123456789',
    experience: '2-3 năm',
    coverLetter: 'This is a test application'
  };
  
  const testJob = {
    title: 'Test Developer',
    id: '999',
    department: 'IT',
    location: 'Test Location'
  };
  
  return await sendJobApplication(testData, testJob);
};

export default {
  initEmailJS,
  sendJobApplication,
  sendContactForm,
  sendSubscription,
  openEmailClient,
  testEmailJS,
  EMAIL_CONFIG,
  COMPANY_CONFIG
}; 